module.exports = __webpack_public_path__ + "assets/img/news-1.d541cae5.jpg";